export default __webpack_public_path__ + "static/media/no-image.63cfb78d.jpg";